export default __webpack_public_path__ + "static/media/108.4530994c.jpeg";